import React, { createContext, useState, useContext, useEffect } from 'react';
import { axiosInstance } from '../lib/axio';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [preloading, setPreloading] = useState(true);
  const [blogListArray, setBlogListArray] = useState([]);

  useEffect(() => {
    const preLoadingFunction = async () => {
      try {
        const response = await axiosInstance.get("blogs/latest-blogs");
        if (response.data.success) {
          setBlogListArray(response.data.blogs); // Set blogs data
        }
      } catch (error) {
        console.error("Error during preload:", error);
      } finally {
        setTimeout(() => setPreloading(false), 500); // Smooth transition
      }
    };

    preLoadingFunction();
  }, []);




  useEffect(() => {
    const checkStatus = async () => {
      try {
        const response = await axiosInstance.get('/user/me');
        console.log(response)
        if (response.data) {
          setIsAuthenticated(true);
          setCurrentUser(response.data);
        } else {
          setIsAuthenticated(false);
          setCurrentUser({});
        }
      } catch (error) {
        console.error('Error checking authentication status:', error);
      }
    };


    checkStatus();
  }, [isAuthenticated]);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setCurrentUser({});
  };


  return (
    <AuthContext.Provider value={{ preloading, setPreloading, blogListArray, login, logout, currentUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
